module.exports = __webpack_public_path__ + "media/account/components/SignInPage/OauthAuth/icon_facebook-f53202d354f8dfc00c84ba1f5292bf39.png";